import { useTranslation } from "react-i18next";
import { moneyFormat } from "../../../../plugins/numberFormat";
import { envChangeType } from "../../../../plugins/utils";
import styles from "./style.module.scss";

const CashReward = ({ key }) => {
  const { t } = useTranslation();

  const data = [
    {
      type: styles.label,
      level: t("label.level"),
      invite: t("label.invite"),
      inviteAmount: t("label.inviteAmount"),
      reward: t("label.reward"),
    },
    {
      type: styles.cell,
      level: "VIP1",
      invite: 3,
      inviteAmount: t(`share.cashReward.more`, {
        money: moneyFormat(1000),
        currency: t(`currency.unit.${envChangeType("REACT_APP_DEFAULT_CURRENCY")}`),
      }),
      reward: (
        <div className={styles.reward}>
          {moneyFormat(500) +
            " " +
            t(`currency.unit.${envChangeType("REACT_APP_DEFAULT_CURRENCY")}`)}
        </div>
      ),
    },
    {
      type: styles.cell,
      level: "VIP2",
      invite: 7,
      inviteAmount: t(`share.cashReward.more`, {
        money: moneyFormat(1000),
        currency: t(`currency.unit.${envChangeType("REACT_APP_DEFAULT_CURRENCY")}`),
      }),
      reward: (
        <div className={styles.reward}>
          {moneyFormat(1200) +
            " " +
            t(`currency.unit.${envChangeType("REACT_APP_DEFAULT_CURRENCY")}`)}
        </div>
      ),
    },
    {
      type: styles.cell,
      level: "VIP3",
      invite: 12,
      inviteAmount: t(`share.cashReward.more`, {
        money: moneyFormat(1000),
        currency: t(`currency.unit.${envChangeType("REACT_APP_DEFAULT_CURRENCY")}`),
      }),
      reward: (
        <div className={styles.reward}>
          {moneyFormat(2100) +
            " " +
            t(`currency.unit.${envChangeType("REACT_APP_DEFAULT_CURRENCY")}`)}
        </div>
      ),
    },
    {
      type: styles.cell,
      level: "VIP4",
      invite: 18,
      inviteAmount: t(`share.cashReward.more`, {
        money: moneyFormat(1000),
        currency: t(`currency.unit.${envChangeType("REACT_APP_DEFAULT_CURRENCY")}`),
      }),
      reward: (
        <div className={styles.reward}>
          {moneyFormat(3300) +
            " " +
            t(`currency.unit.${envChangeType("REACT_APP_DEFAULT_CURRENCY")}`)}
        </div>
      ),
    },
    {
      type: styles.cell,
      level: "VIP5",
      invite: 25,
      inviteAmount: t(`share.cashReward.more`, {
        money: moneyFormat(1000),
        currency: t(`currency.unit.${envChangeType("REACT_APP_DEFAULT_CURRENCY")}`),
      }),
      reward: (
        <div className={styles.reward}>
          {moneyFormat(4700) +
            " " +
            t(`currency.unit.${envChangeType("REACT_APP_DEFAULT_CURRENCY")}`)}
        </div>
      ),
    },
    {
      type: styles.cell,
      level: "VIP6",
      invite: 33,
      inviteAmount: t(`share.cashReward.more`, {
        money: moneyFormat(1000),
        currency: t(`currency.unit.${envChangeType("REACT_APP_DEFAULT_CURRENCY")}`),
      }),
      reward: (
        <div className={styles.reward}>
          {moneyFormat(6300) +
            " " +
            t(`currency.unit.${envChangeType("REACT_APP_DEFAULT_CURRENCY")}`)}
        </div>
      ),
    },
    {
      type: styles.cell,
      level: "VIP7",
      invite: 42,
      inviteAmount: t(`share.cashReward.more`, {
        money: moneyFormat(1000),
        currency: t(`currency.unit.${envChangeType("REACT_APP_DEFAULT_CURRENCY")}`),
      }),
      reward: (
        <div className={styles.reward}>
          {moneyFormat(8200) +
            " " +
            t(`currency.unit.${envChangeType("REACT_APP_DEFAULT_CURRENCY")}`)}
        </div>
      ),
    },
    {
      type: styles.cell,
      level: "VIP8",
      invite: 52,
      inviteAmount: t(`share.cashReward.more`, {
        money: moneyFormat(1000),
        currency: t(`currency.unit.${envChangeType("REACT_APP_DEFAULT_CURRENCY")}`),
      }),
      reward: (
        <div className={styles.reward}>
          {moneyFormat(10500) +
            " " +
            t(`currency.unit.${envChangeType("REACT_APP_DEFAULT_CURRENCY")}`)}
        </div>
      ),
    },
    {
      type: styles.cell,
      level: "VIP9",
      invite: 63,
      inviteAmount: t(`share.cashReward.more`, {
        money: moneyFormat(1000),
        currency: t(`currency.unit.${envChangeType("REACT_APP_DEFAULT_CURRENCY")}`),
      }),
      reward: (
        <div className={styles.reward}>
          {moneyFormat(13000) +
            " " +
            t(`currency.unit.${envChangeType("REACT_APP_DEFAULT_CURRENCY")}`)}
        </div>
      ),
    },
    {
      type: styles.cell,
      level: "VIP10",
      invite: 75,
      inviteAmount: t(`share.cashReward.more`, {
        money: moneyFormat(1000),
        currency: t(`currency.unit.${envChangeType("REACT_APP_DEFAULT_CURRENCY")}`),
      }),
      reward: (
        <div className={styles.reward}>
          {moneyFormat(16000) +
            " " +
            t(`currency.unit.${envChangeType("REACT_APP_DEFAULT_CURRENCY")}`)}
        </div>
      ),
    },
  ];

  return (
    <div className={styles.cashReward} key={key}>
      <div className={styles.title}>{t(`share.cashReward`)}</div>
      <div
        className={styles.content}
        dangerouslySetInnerHTML={{
          __html: t(`share.cashReward.content`, {
            currency: t(`currency.unit.${envChangeType("REACT_APP_DEFAULT_CURRENCY")}`),
          }),
        }}
      />
      <div className={styles.table}>
        {data.map((item, index) => (
          <div key={index} className={styles.row}>
            <div className={`${styles.box} ${item.type}`}>{item.level}</div>
            <div className={`${styles.box} ${item.type}`}>{item.invite}</div>
            <div className={`${styles.box} ${item.type}`}>{item.inviteAmount}</div>
            <div className={`${styles.box} ${item.type}`}>{item.reward}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CashReward;
